import React from 'react';
import './Features.css';

const Features = () => {
    const services = [
        {
            title: '信息系统开发',
            description: '定制化企业管理系统、ERP系统、OA系统、CRM系统等，助力企业提升运营效率',
            image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            alt: '信息系统开发'
        },
        {
            title: 'APP开发',
            description: '原生Android/iOS开发、跨平台React Native开发，打造体验卓越的移动应用',
            image: 'https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            alt: 'APP开发'
        },
        {
            title: '小程序开发',
            description: '微信小程序、支付宝小程序、抖音小程序，快速迭代，低成本获客，赋能商业生态',
            image: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            alt: '小程序开发'
        },
        {
            title: '人工智能服务',
            description: 'AI模型训练、计算机视觉、自然语言处理、智能推荐系统，用AI技术驱动业务创新',
            image: 'https://images.unsplash.com/photo-1555255707-c07966088b7b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
            alt: '人工智能服务'
        }
    ];

    return  <section id="features" className="features-section">
        <div className="section-header">
            <h2>主营业务</h2>
            <p>我们产品的独特卖点</p>
        </div>
        <div className="features-grid">
            {services.map((service, index) => (
                <div key={index} className="feature-card">
                    <div className="feature-image-wrapper">
                        <img
                            src={service.image}
                            alt={service.alt}
                            className="feature-image"
                            loading="lazy"
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = 'https://via.placeholder.com/800x600/667eea/ffffff?text=' + encodeURIComponent(service.title);
                            }}
                        />
                        <div className="feature-overlay">
                            <span className="feature-tag">了解更多</span>
                        </div>
                    </div>
                    <div className="feature-content">
                        <h3>{service.title}</h3>
                        <p>{service.description}</p>
                    </div>
                </div>
            ))}
        </div>
    </section>
}

export default Features;